import apiClient from '@utils/apiClient';
import {
    MapFeatureReq,
    MapFeatureRes,
    MapFeatureData,
    AddressData,
    AddressSearchReq,
    AddressRes,
    MapFeatureListReq,
    MapFeatureListRes,
} from './type.ts';
import { ApiOptions } from '@/api/common/type';

export const api = {
    /**
     * 지적도객체조회
     * @param param
     * @param options
     */
    getMapFeature: async (
        param: MapFeatureReq,
        options: ApiOptions = {},
    ): Promise<MapFeatureData> => {
        const response = await apiClient.post<MapFeatureRes>(
            '/api/v1/growth/map/feature',
            param,
            {
                skipLoading: options.skipLoading,
            } as any, // 👈 타입 단언으로 해결
        );
        return response.data.data;
    },

    /**
     * 지적도객체조회-다중
     * @param param
     * @param options
     */
    getMapFeatureBox: async (
        param: MapFeatureListReq,
        options: ApiOptions = {},
    ): Promise<MapFeatureListRes> => {
        const response = await apiClient.post<MapFeatureListRes>(
            '/api/v1/growth/map/feature/box',
            param,
            {
                skipLoading: options.skipLoading,
            } as any, // 👈 타입 단언으로 해결
        );
        return response.data;
    },

    /**
     * 주소검색
     * @param param
     * @param options
     */
    searchAddress: async (
        param: AddressSearchReq,
        options: ApiOptions = {},
    ): Promise<AddressData> => {
        const response = await apiClient.get<AddressRes>(
            '/api/v1/growth/map/search/address',
            {
                params: param,
                skipLoading: options.skipLoading,
            } as any,
        );
        return response.data.data;
    },
};
